export const AUTOMATIC_WORKSPACE_ACCESS_ERROR = "PapersFlow could not create this device session.";

interface AnonymousAccessClient {
  readonly signIn: {
    readonly anonymous: () => Promise<{ readonly error?: unknown }>;
  };
}

export interface WorkspaceAccessBootstrap {
  readonly start: () => Promise<void>;
}

export function createWorkspaceAccessBootstrap(
  authClient: AnonymousAccessClient,
): WorkspaceAccessBootstrap {
  let request: Promise<void> | undefined;

  return {
    start: () => {
      request ??= Promise.resolve()
        .then(() => authClient.signIn.anonymous())
        .then(
          (result) => {
            if (result.error) throw new Error(AUTOMATIC_WORKSPACE_ACCESS_ERROR);
            return undefined;
          },
          () => {
            throw new Error(AUTOMATIC_WORKSPACE_ACCESS_ERROR);
          },
        );
      return request;
    },
  };
}
